import React                     from 'react';
import { connect }               from 'react-redux';
import { updateSetting }         from '../../../store/actions/TemplateAction';
import RichAlert                 from '../feeback/RichAlert';
import { Trans, useTranslation } from 'react-i18next';
import Button                      from '../inputs/Button';
import {Grid, TableCell, TableRow} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery             from '@mui/material/useMediaQuery';

const FanclubActivator = ({ setting, updating, enableFanclub, isAdmin, hasFanclub, short = false, taskCenter=false }) => {
	const { t } = useTranslation();

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });

	if (!setting.Setting__ || !isAdmin || !hasFanclub) return <></>; // Some custom website were integrated with PXL but does not have this settings system
	if (setting.Data.fanclub_visible === 'Y') return <></>;

	const activate = () => {
		enableFanclub(setting.Setting__);
	};

	if(taskCenter) {
		return (
			<TableRow>
				<TableCell>
					<Trans i18nKey={(short || isMobile) ? 'activate_fanclub_warning_short' : 'activate_fanclub_warning'}>
						sample<br/>
						<strong>sample</strong>
					</Trans>
				</TableCell>
				<TableCell align='right'>
					<Button
						onClick={activate}
						color='primary'
						loading={updating}
						disabled={updating}
						variant='contained'
						size='small'
					>
						{t('activate_fanclub_btn')}
					</Button>
				</TableCell>
			</TableRow>
		)
	}

	return (
		<Grid item xs={12}>
			<RichAlert
				severity='warning'
				action={
					<Button
						onClick={activate}
						color='primary'
						loading={updating}
						disabled={updating}
						variant='contained'
						size='small'
					>
						{t('activate_fanclub_btn')}
					</Button>
				}
			>
				<Trans i18nKey={(short || isMobile) ? 'activate_fanclub_warning_short' : 'activate_fanclub_warning'}>
					sample<br/>
					<strong>sample</strong>
				</Trans>
			</RichAlert>
		</Grid>
	);
};

const mapStateToProps = (state) => {
	return {
		setting: state.template.templateSettings,
		updating: state.template.updatingTemplate,
		hasFanclub: state.membership.selectedFanclub,
		isAdmin: state.access.admin
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		enableFanclub: (settingId) => dispatch(updateSetting(settingId, 'fanclub_visible', 'Y', 'activate_fanclub_success'))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(FanclubActivator);
